import { Box, Container, useMediaQuery } from "@mui/material";
import React, { useEffect } from "react";
import { NAVBAR_HEIGHT } from "../Navbar/Navbar";
import { navbarBlue } from "../../Classes/theme";
import BackgroundSvg from "./Background";

const height = { xs: "950px", sm: "1000px", md: "570px" };

export default function BgLayout({
  image = null,
  children = <></>,
  sxProps = {},
  sxContainer = {},
  sxChild = {},
  color = navbarBlue,
}) {
  const xxxs = useMediaQuery("(max-width:475px)");
  const xxs = useMediaQuery("(max-width:540px)");
  const backgroundImage = BackgroundSvg({ color });

  function getMinSize() {
    if (xxxs) {
      return '890px';
    }
    if (xxs) {
      return '1000px';
    }
    return '920px';
  }

  return (
    <Container
      maxWidth="lg"
      sx={{
        px: "0px !important",
        overflow: "visible",
        height: '100%',
        minHeight: height,
        ...sxContainer,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          position: "absolute",
          width: { xs: '100%', sm: '100%', md: "100vw" },
          left: 0,
          top: 0,
          backgroundImage,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          height: height,
          minWidth: { xs: getMinSize(), sm: "960px", md: "1050px", lg: 'auto' },
          ...sxProps,
        }}
      />

      <Box sx={{
        pt: `${NAVBAR_HEIGHT}px`, height: height, display: 'flex',
        ...sxChild
      }}>
        <Container maxWidth='lg' sx={{ pl: '0px !important', position: "relative" }}>
          {children}
        </Container>
      </Box>
    </Container>
  );
}
